import React from 'react'
import { details, Logo } from '../common'
// import logo from '../../images/companyLogo.png'
const logo = "https://technologytherapy.com/wp-content/themes/ttg/dist/images/logo.png"

export default () => <a href={details.site}><Logo src={logo} alt={`${details.store} logo`} /></a>
